import * as React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { App } from './App';
import { store } from './store';

import './index.css';

import CustomToast from './components/Layout/SellerAgent/Negotiation/Component/customtoast';

// The session token is shared by every tab. When another tab signs out or
// into a different account, this tab's requests would silently switch
// accounts — start it over from the home page instead.
window.addEventListener('storage', (e) => {
  if (e.key === 'token' && e.oldValue !== e.newValue) {
    window.location.assign('/');
  }
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <CustomToast />
      <App />
    </Provider>
  </React.StrictMode>
);
